import { ReactNode, createContext, useContext, useState } from "react";

// 회원기본정보 등록 Params Context
export interface initialCreateParamsProps {
  manSurnm: string;
  manFstnm: string;
  manEmlId: string;
  mobCntyCd: string;
  mobNo: string;
}

interface BaseResetPwdParamContextType {
  param: initialCreateParamsProps;
  onChange: (name: string, value: string) => void;
  onSelect: (name: string, value: string) => void;
  onReset: () => void;
}

const BaseResetPwdParamContext = createContext<
  BaseResetPwdParamContextType | undefined
>(undefined);

interface BaseResetPwdParamProviderProps {
  children: ReactNode;
}

export const BaseResetPwdParamProvider = ({
  children,
}: BaseResetPwdParamProviderProps) => {
  const initialFilterState = {
    manSurnm: "",
    manFstnm: "",
    manEmlId: "",
    mobCntyCd: "+82",
    mobNo: "",
  };

  const [param, setParam] =
    useState<initialCreateParamsProps>(initialFilterState);

  const onChange = (name: string, value: string) => {
    setParam({
      ...param,
      [name]: value,
    });
  };

  const onSelect = (name: string, value: string | any) => {
    setParam({
      ...param,
      [name]: value,
    });
  };

  const onReset = () => {
    setParam(initialFilterState);
  };

  return (
    <BaseResetPwdParamContext.Provider
      value={{
        param,
        onChange,
        onSelect,
        onReset,
      }}
    >
      {children}
    </BaseResetPwdParamContext.Provider>
  );
};

export const useBaseResetPwdParamContext = (): BaseResetPwdParamContextType => {
  const context = useContext(BaseResetPwdParamContext);

  if (!context) {
    throw new Error(
      "useBaseResetPwdParamContext는 BaseResetPwdParamProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};
